// leaving this in incase we need a hook into again later
const getOtmmUrl = (requestPath) => {
  return `${requestPath}`;
};

export default getOtmmUrl;
